import React from "react";

export const WidgetsBarContext = React.createContext({});
